import api from './api';

export const salesService = {
  // Deals
  getDeals: async (params = {}) => {
    const response = await api.get('/v1/sales/deals/', { params });
    return response.data;
  },

  getDeal: async (id) => {
    const response = await api.get(`/v1/sales/deals/${id}/`);
    return response.data;
  },

  createDeal: async (dealData) => {
    const response = await api.post('/v1/sales/deals/', dealData);
    return response.data;
  },

  updateDeal: async (id, dealData) => {
    const response = await api.put(`/v1/sales/deals/${id}/`, dealData);
    return response.data;
  },

  deleteDeal: async (id) => {
    const response = await api.delete(`/v1/sales/deals/${id}/`);
    return response.data;
  },

  // Get deal statistics
  getDealStats: async () => {
    const response = await api.get('/v1/sales/deals/stats/');
    return response.data;
  },

  // Get test drives for a deal
  getDealTestDrives: async (dealId) => {
    const response = await api.get(`/v1/sales/deals/${dealId}/test_drives/`);
    return response.data;
  },

  // Add test drive to a deal
  addDealTestDrive: async (dealId, testDriveData) => {
    const response = await api.post(`/v1/sales/deals/${dealId}/add_test_drive/`, testDriveData);
    return response.data;
  },

  // Get quotes for a deal
  getDealQuotes: async (dealId) => {
    const response = await api.get(`/v1/sales/deals/${dealId}/quotes/`);
    return response.data;
  },

  // Add quote to a deal
  addDealQuote: async (dealId, quoteData) => {
    const response = await api.post(`/v1/sales/deals/${dealId}/add_quote/`, quoteData);
    return response.data;
  },

  // Test Drives
  getTestDrives: async (params = {}) => {
    const response = await api.get('/v1/sales/test-drives/', { params });
    return response.data;
  },

  getTestDrive: async (id) => {
    const response = await api.get(`/v1/sales/test-drives/${id}/`);
    return response.data;
  },

  createTestDrive: async (testDriveData) => {
    const response = await api.post('/v1/sales/test-drives/', testDriveData);
    return response.data;
  },

  updateTestDrive: async (id, testDriveData) => {
    const response = await api.put(`/v1/sales/test-drives/${id}/`, testDriveData);
    return response.data;
  },

  deleteTestDrive: async (id) => {
    const response = await api.delete(`/v1/sales/test-drives/${id}/`);
    return response.data;
  },

  // Quotes
  getQuotes: async (params = {}) => {
    const response = await api.get('/v1/sales/quotes/', { params });
    return response.data;
  },

  getQuote: async (id) => {
    const response = await api.get(`/v1/sales/quotes/${id}/`);
    return response.data;
  },

  createQuote: async (quoteData) => {
    const response = await api.post('/v1/sales/quotes/', quoteData);
    return response.data;
  },

  updateQuote: async (id, quoteData) => {
    const response = await api.put(`/v1/sales/quotes/${id}/`, quoteData);
    return response.data;
  },

  deleteQuote: async (id) => {
    const response = await api.delete(`/v1/sales/quotes/${id}/`);
    return response.data;
  },
};